import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ServiceProviderDashboardSidebar from "./ServiceProviderDashboardSidebar/ServiceProviderDashboardSidebar";
import ServiceProviderDashboardContent from "./ServiceProviderDashboardContent/ServiceProviderDashboardContent";
import { getAllServiceProviders } from "../../actions/serviceProviderActions";

import "./style.css";

const DashboardMainPage = () => {
  const { user } = useSelector((state) => state.userLogin);
  const { serviceProvider } = useSelector((state) => state.getServiceProvider);
  const dispatch = useDispatch();
  const requestedProvider = useRef(false);

  // Provider details are only fetched on sign-in / home, so a provider landing
  // here directly (e.g. straight after verification or Stripe onboarding) has
  // no serviceProvider in the store. Fetch it once so forms have its id.
  useEffect(() => {
    if (user?.access && !serviceProvider?.id && !requestedProvider.current) {
      requestedProvider.current = true;
      dispatch(getAllServiceProviders());
    }
  }, [user, serviceProvider, dispatch]);

  return (
    <div className="d-flex"style={{backgroundColor:'#F5F6FA'}} >
      <div className="d-none d-lg-block seller-dashboard-sidebar">
        <ServiceProviderDashboardSidebar />
      </div>
      <div
        className="seller-dashboard-content"
        style={{backgroundColor:'#F5F6FA'}}
      >
        <div className="container-fluid p-1 p-md-3">
          <ServiceProviderDashboardContent />
        </div>
      </div>
    </div>
  );
};

export default DashboardMainPage;
